"use strict";
export const searchTherapistSearchParams = validate11;
const schema12 = { "$id": "#/definitions/searchTherapistSearchParams", "type": "object", "additionalProperties": false, "properties": { "address": { "type": ["string", "null"], "minLength": 1, "maxLength": 1000 }, "therapeuticFocus": { "type": "array", "items": { "type": "string" }, "minItems": 0, "maxItems": 1000, "uniqueItems": true }, "treatmentMethods": { "type": "array", "items": { "type": "string" }, "minItems": 0, "maxItems": 1000, "uniqueItems": true }, "jobTitleTypes": { "type": "array", "items": { "type": "string", "enum": ["psychologicalPsychotherapist", "psychologicalPsychotherapistChildren", "specialistPsychiatryPsychotherapy", "specialistPsychiatryPsychotherapyChildren", "specialistPsychosomatics", "physicianAdditionalQualificationPsychotherapy", "nonMedicalPractitionerPsychotherapy", "socialPedagogue", "coachOrConsultant"] }, "minItems": 0, "maxItems": 1000, "uniqueItems": true }, "languages": { "type": "array", "items": { "type": "string", "minLength": 2, "maxLength": 2 }, "minItems": 0, "maxItems": 1000, "uniqueItems": true }, "coverageTypes": { "type": "array", "items": { "type": "string", "enum": ["Private Health Insurance", "Statutory Health Insurance", "Self-Payment", "Reimbursement Procedure"] }, "minItems": 0, "maxItems": 1000, "uniqueItems": true }, "gender": { "type": "array", "items": { "type": "string", "enum": ["female", "male", "diverse"] }, "minItems": 0, "maxItems": 3, "uniqueItems": true }, "location": { "type": "array", "items": { "type": "string", "enum": ["onSite", "remote"] }, "minItems": 0, "maxItems": 2, "uniqueItems": true }, "sort": { "type": ["string", "null"], "enum": ["distance", "availability", null] }, "therapistId": { "type": "string", "format": "decimal" }, "insuranseType": { "type": "string", "enum": ["legally", "privately"] }, "meetingTypeId": { "type": "string", "format": "decimal" }, "appointmentsFrom": { "type": "string", "format": "date-time" }, "page": { "type": "number", "minimum": 1 }, "limit": { "type": "number", "minimum": 1, "maximum": 100 } }, "required": [] };
const func2 = Object.prototype.hasOwnProperty;
import __req_func3 from "ajv/dist/runtime/ucs2length.js";
const func3 = __req_func3.default;
import __req_formats0 from "../formats.js";
const formats0 = __req_formats0.decimal;
import __req_formats4 from "../formats.js";
const formats4 = __req_formats4["date-time"];
function validate11(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="#/definitions/searchTherapistSearchParams" */ ;
    let vErrors = null;
    let errors = 0;
    if (data && typeof data == "object" && !Array.isArray(data)) {
        for (const key0 in data) {
            if (!(func2.call(schema12.properties, key0))) {
                const err0 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
        if (data.address !== undefined) {
            let data0 = data.address;
            if ((typeof data0 !== "string") && (data0 !== null)) {
                let dataType0 = typeof data0;
                let coerced0 = undefined;
                if (dataType0 == 'object' && Array.isArray(data0) && data0.length == 1) {
                    data0 = data0[0];
                    dataType0 = typeof data0;
                    if ((typeof data0 === "string") && (data0 === null)) {
                        coerced0 = data0;
                    }
                }
                if (!(coerced0 !== undefined)) {
                    if (dataType0 == "number" || dataType0 == "boolean") {
                        coerced0 = "" + data0;
                    }
                    else if (data0 === null) {
                        coerced0 = "";
                    }
                    else if (data0 === "" || data0 === 0 || data0 === false) {
                        coerced0 = null;
                    }
                    else {
                        const err1 = { instancePath: instancePath + "/address", schemaPath: "#/properties/address/type", keyword: "type", params: { type: schema12.properties.address.type }, message: "must be string,null" };
                        if (vErrors === null) {
                            vErrors = [err1];
                        }
                        else {
                            vErrors.push(err1);
                        }
                        errors++;
                    }
                }
                if (coerced0 !== undefined) {
                    data0 = coerced0;
                    if (data !== undefined) {
                        data["address"] = coerced0;
                    }
                }
            }
            if (typeof data0 === "string") {
                if (func3(data0) > 1000) {
                    const err2 = { instancePath: instancePath + "/address", schemaPath: "#/properties/address/maxLength", keyword: "maxLength", params: { limit: 1000 }, message: "must NOT have more than 1000 characters" };
                    if (vErrors === null) {
                        vErrors = [err2];
                    }
                    else {
                        vErrors.push(err2);
                    }
                    errors++;
                }
                if (func3(data0) < 1) {
                    const err3 = { instancePath: instancePath + "/address", schemaPath: "#/properties/address/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                    if (vErrors === null) {
                        vErrors = [err3];
                    }
                    else {
                        vErrors.push(err3);
                    }
                    errors++;
                }
            }
        }
        if (data.therapeuticFocus !== undefined) {
            let data1 = data.therapeuticFocus;
            if (!(Array.isArray(data1))) {
                let dataType1 = typeof data1;
                let coerced1 = undefined;
                if (dataType1 == 'object' && Array.isArray(data1) && data1.length == 1) {
                    data1 = data1[0];
                    dataType1 = typeof data1;
                    if (Array.isArray(data1)) {
                        coerced1 = data1;
                    }
                }
                if (!(coerced1 !== undefined)) {
                    if (dataType1 === "string" || dataType1 === "number"
                        || dataType1 === "boolean" || data1 === null) {
                        coerced1 = [data1];
                    }
                    else {
                        const err4 = { instancePath: instancePath + "/therapeuticFocus", schemaPath: "#/properties/therapeuticFocus/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                        if (vErrors === null) {
                            vErrors = [err4];
                        }
                        else {
                            vErrors.push(err4);
                        }
                        errors++;
                    }
                }
                if (coerced1 !== undefined) {
                    data1 = coerced1;
                    if (data !== undefined) {
                        data["therapeuticFocus"] = coerced1;
                    }
                }
            }
            if (Array.isArray(data1)) {
                if (data1.length > 1000) {
                    const err5 = { instancePath: instancePath + "/therapeuticFocus", schemaPath: "#/properties/therapeuticFocus/maxItems", keyword: "maxItems", params: { limit: 1000 }, message: "must NOT have more than 1000 items" };
                    if (vErrors === null) {
                        vErrors = [err5];
                    }
                    else {
                        vErrors.push(err5);
                    }
                    errors++;
                }
                if (data1.length < 0) {
                    const err6 = { instancePath: instancePath + "/therapeuticFocus", schemaPath: "#/properties/therapeuticFocus/minItems", keyword: "minItems", params: { limit: 0 }, message: "must NOT have fewer than 0 items" };
                    if (vErrors === null) {
                        vErrors = [err6];
                    }
                    else {
                        vErrors.push(err6);
                    }
                    errors++;
                }
                const len0 = data1.length;
                for (let i0 = 0; i0 < len0; i0++) {
                    let data2 = data1[i0];
                    if (typeof data2 !== "string") {
                        let dataType2 = typeof data2;
                        let coerced2 = undefined;
                        if (dataType2 == 'object' && Array.isArray(data2) && data2.length == 1) {
                            data2 = data2[0];
                            dataType2 = typeof data2;
                            if (typeof data2 === "string") {
                                coerced2 = data2;
                            }
                        }
                        if (!(coerced2 !== undefined)) {
                            if (dataType2 == "number" || dataType2 == "boolean") {
                                coerced2 = "" + data2;
                            }
                            else if (data2 === null) {
                                coerced2 = "";
                            }
                            else {
                                const err7 = { instancePath: instancePath + "/therapeuticFocus/" + i0, schemaPath: "#/properties/therapeuticFocus/items/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                    vErrors = [err7];
                                }
                                else {
                                    vErrors.push(err7);
                                }
                                errors++;
                            }
                        }
                        if (coerced2 !== undefined) {
                            data2 = coerced2;
                            if (data1 !== undefined) {
                                data1[i0] = coerced2;
                            }
                        }
                    }
                }
                let i1 = data1.length;
                let j0;
                if (i1 > 1) {
                    const indices0 = {};
                    for (; i1--;) {
                        let item0 = data1[i1];
                        if (typeof item0 !== "string") {
                            continue;
                        }
                        if (typeof indices0[item0] == "number") {
                            j0 = indices0[item0];
                            const err8 = { instancePath: instancePath + "/therapeuticFocus", schemaPath: "#/properties/therapeuticFocus/uniqueItems", keyword: "uniqueItems", params: { i: i1, j: j0 }, message: "must NOT have duplicate items (items ## " + j0 + " and " + i1 + " are identical)" };
                            if (vErrors === null) {
                                vErrors = [err8];
                            }
                            else {
                                vErrors.push(err8);
                            }
                            errors++;
                            break;
                        }
                        indices0[item0] = i1;
                    }
                }
            }
        }
        if (data.treatmentMethods !== undefined) {
            let data3 = data.treatmentMethods;
            if (!(Array.isArray(data3))) {
                let dataType3 = typeof data3;
                let coerced3 = undefined;
                if (dataType3 == 'object' && Array.isArray(data3) && data3.length == 1) {
                    data3 = data3[0];
                    dataType3 = typeof data3;
                    if (Array.isArray(data3)) {
                        coerced3 = data3;
                    }
                }
                if (!(coerced3 !== undefined)) {
                    if (dataType3 === "string" || dataType3 === "number"
                        || dataType3 === "boolean" || data3 === null) {
                        coerced3 = [data3];
                    }
                    else {
                        const err9 = { instancePath: instancePath + "/treatmentMethods", schemaPath: "#/properties/treatmentMethods/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                        if (vErrors === null) {
                            vErrors = [err9];
                        }
                        else {
                            vErrors.push(err9);
                        }
                        errors++;
                    }
                }
                if (coerced3 !== undefined) {
                    data3 = coerced3;
                    if (data !== undefined) {
                        data["treatmentMethods"] = coerced3;
                    }
                }
            }
            if (Array.isArray(data3)) {
                if (data3.length > 1000) {
                    const err10 = { instancePath: instancePath + "/treatmentMethods", schemaPath: "#/properties/treatmentMethods/maxItems", keyword: "maxItems", params: { limit: 1000 }, message: "must NOT have more than 1000 items" };
                    if (vErrors === null) {
                        vErrors = [err10];
                    }
                    else {
                        vErrors.push(err10);
                    }
                    errors++;
                }
                if (data3.length < 0) {
                    const err11 = { instancePath: instancePath + "/treatmentMethods", schemaPath: "#/properties/treatmentMethods/minItems", keyword: "minItems", params: { limit: 0 }, message: "must NOT have fewer than 0 items" };
                    if (vErrors === null) {
                        vErrors = [err11];
                    }
                    else {
                        vErrors.push(err11);
                    }
                    errors++;
                }
                const len1 = data3.length;
                for (let i2 = 0; i2 < len1; i2++) {
                    let data4 = data3[i2];
                    if (typeof data4 !== "string") {
                        let dataType4 = typeof data4;
                        let coerced4 = undefined;
                        if (dataType4 == 'object' && Array.isArray(data4) && data4.length == 1) {
                            data4 = data4[0];
                            dataType4 = typeof data4;
                            if (typeof data4 === "string") {
                                coerced4 = data4;
                            }
                        }
                        if (!(coerced4 !== undefined)) {
                            if (dataType4 == "number" || dataType4 == "boolean") {
                                coerced4 = "" + data4;
                            }
                            else if (data4 === null) {
                                coerced4 = "";
                            }
                            else {
                                const err12 = { instancePath: instancePath + "/treatmentMethods/" + i2, schemaPath: "#/properties/treatmentMethods/items/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                    vErrors = [err12];
                                }
                                else {
                                    vErrors.push(err12);
                                }
                                errors++;
                            }
                        }
                        if (coerced4 !== undefined) {
                            data4 = coerced4;
                            if (data3 !== undefined) {
                                data3[i2] = coerced4;
                            }
                        }
                    }
                }
                let i3 = data3.length;
                let j1;
                if (i3 > 1) {
                    const indices1 = {};
                    for (; i3--;) {
                        let item1 = data3[i3];
                        if (typeof item1 !== "string") {
                            continue;
                        }
                        if (typeof indices1[item1] == "number") {
                            j1 = indices1[item1];
                            const err13 = { instancePath: instancePath + "/treatmentMethods", schemaPath: "#/properties/treatmentMethods/uniqueItems", keyword: "uniqueItems", params: { i: i3, j: j1 }, message: "must NOT have duplicate items (items ## " + j1 + " and " + i3 + " are identical)" };
                            if (vErrors === null) {
                                vErrors = [err13];
                            }
                            else {
                                vErrors.push(err13);
                            }
                            errors++;
                            break;
                        }
                        indices1[item1] = i3;
                    }
                }
            }
        }
        if (data.jobTitleTypes !== undefined) {
            let data5 = data.jobTitleTypes;
            if (!(Array.isArray(data5))) {
                let dataType5 = typeof data5;
                let coerced5 = undefined;
                if (dataType5 == 'object' && Array.isArray(data5) && data5.length == 1) {
                    data5 = data5[0];
                    dataType5 = typeof data5;
                    if (Array.isArray(data5)) {
                        coerced5 = data5;
                    }
                }
                if (!(coerced5 !== undefined)) {
                    if (dataType5 === "string" || dataType5 === "number"
                        || dataType5 === "boolean" || data5 === null) {
                        coerced5 = [data5];
                    }
                    else {
                        const err14 = { instancePath: instancePath + "/jobTitleTypes", schemaPath: "#/properties/jobTitleTypes/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                        if (vErrors === null) {
                            vErrors = [err14];
                        }
                        else {
                            vErrors.push(err14);
                        }
                        errors++;
                    }
                }
                if (coerced5 !== undefined) {
                    data5 = coerced5;
                    if (data !== undefined) {
                        data["jobTitleTypes"] = coerced5;
                    }
                }
            }
            if (Array.isArray(data5)) {
                if (data5.length > 1000) {
                    const err15 = { instancePath: instancePath + "/jobTitleTypes", schemaPath: "#/properties/jobTitleTypes/maxItems", keyword: "maxItems", params: { limit: 1000 }, message: "must NOT have more than 1000 items" };
                    if (vErrors === null) {
                        vErrors = [err15];
                    }
                    else {
                        vErrors.push(err15);
                    }
                    errors++;
                }
                if (data5.length < 0) {
                    const err16 = { instancePath: instancePath + "/jobTitleTypes", schemaPath: "#/properties/jobTitleTypes/minItems", keyword: "minItems", params: { limit: 0 }, message: "must NOT have fewer than 0 items" };
                    if (vErrors === null) {
                        vErrors = [err16];
                    }
                    else {
                        vErrors.push(err16);
                    }
                    errors++;
                }
                const len2 = data5.length;
                for (let i4 = 0; i4 < len2; i4++) {
                    let data6 = data5[i4];
                    if (typeof data6 !== "string") {
                        let dataType6 = typeof data6;
                        let coerced6 = undefined;
                        if (dataType6 == 'object' && Array.isArray(data6) && data6.length == 1) {
                            data6 = data6[0];
                            dataType6 = typeof data6;
                            if (typeof data6 === "string") {
                                coerced6 = data6;
                            }
                        }
                        if (!(coerced6 !== undefined)) {
                            if (dataType6 == "number" || dataType6 == "boolean") {
                                coerced6 = "" + data6;
                            }
                            else if (data6 === null) {
                                coerced6 = "";
                            }
                            else {
                                const err17 = { instancePath: instancePath + "/jobTitleTypes/" + i4, schemaPath: "#/properties/jobTitleTypes/items/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                    vErrors = [err17];
                                }
                                else {
                                    vErrors.push(err17);
                                }
                                errors++;
                            }
                        }
                        if (coerced6 !== undefined) {
                            data6 = coerced6;
                            if (data5 !== undefined) {
                                data5[i4] = coerced6;
                            }
                        }
                    }
                    if (!(((((((((data6 === "psychologicalPsychotherapist") || (data6 === "psychologicalPsychotherapistChildren")) || (data6 === "specialistPsychiatryPsychotherapy")) || (data6 === "specialistPsychiatryPsychotherapyChildren")) || (data6 === "specialistPsychosomatics")) || (data6 === "physicianAdditionalQualificationPsychotherapy")) || (data6 === "nonMedicalPractitionerPsychotherapy")) || (data6 === "socialPedagogue")) || (data6 === "coachOrConsultant"))) {
                        const err18 = { instancePath: instancePath + "/jobTitleTypes/" + i4, schemaPath: "#/properties/jobTitleTypes/items/enum", keyword: "enum", params: { allowedValues: schema12.properties.jobTitleTypes.items.enum }, message: "must be equal to one of the allowed values" };
                        if (vErrors === null) {
                            vErrors = [err18];
                        }
                        else {
                            vErrors.push(err18);
                        }
                        errors++;
                    }
                }
                let i5 = data5.length;
                let j2;
                if (i5 > 1) {
                    const indices2 = {};
                    for (; i5--;) {
                        let item2 = data5[i5];
                        if (typeof item2 !== "string") {
                            continue;
                        }
                        if (typeof indices2[item2] == "number") {
                            j2 = indices2[item2];
                            const err19 = { instancePath: instancePath + "/jobTitleTypes", schemaPath: "#/properties/jobTitleTypes/uniqueItems", keyword: "uniqueItems", params: { i: i5, j: j2 }, message: "must NOT have duplicate items (items ## " + j2 + " and " + i5 + " are identical)" };
                            if (vErrors === null) {
                                vErrors = [err19];
                            }
                            else {
                                vErrors.push(err19);
                            }
                            errors++;
                            break;
                        }
                        indices2[item2] = i5;
                    }
                }
            }
        }
        if (data.languages !== undefined) {
            let data7 = data.languages;
            if (!(Array.isArray(data7))) {
                let dataType7 = typeof data7;
                let coerced7 = undefined;
                if (dataType7 == 'object' && Array.isArray(data7) && data7.length == 1) {
                    data7 = data7[0];
                    dataType7 = typeof data7;
                    if (Array.isArray(data7)) {
                        coerced7 = data7;
                    }
                }
                if (!(coerced7 !== undefined)) {
                    if (dataType7 === "string" || dataType7 === "number"
                        || dataType7 === "boolean" || data7 === null) {
                        coerced7 = [data7];
                    }
                    else {
                        const err20 = { instancePath: instancePath + "/languages", schemaPath: "#/properties/languages/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                        if (vErrors === null) {
                            vErrors = [err20];
                        }
                        else {
                            vErrors.push(err20);
                        }
                        errors++;
                    }
                }
                if (coerced7 !== undefined) {
                    data7 = coerced7;
                    if (data !== undefined) {
                        data["languages"] = coerced7;
                    }
                }
            }
            if (Array.isArray(data7)) {
                if (data7.length > 1000) {
                    const err21 = { instancePath: instancePath + "/languages", schemaPath: "#/properties/languages/maxItems", keyword: "maxItems", params: { limit: 1000 }, message: "must NOT have more than 1000 items" };
                    if (vErrors === null) {
                        vErrors = [err21];
                    }
                    else {
                        vErrors.push(err21);
                    }
                    errors++;
                }
                if (data7.length < 0) {
                    const err22 = { instancePath: instancePath + "/languages", schemaPath: "#/properties/languages/minItems", keyword: "minItems", params: { limit: 0 }, message: "must NOT have fewer than 0 items" };
                    if (vErrors === null) {
                        vErrors = [err22];
                    }
                    else {
                        vErrors.push(err22);
                    }
                    errors++;
                }
                const len3 = data7.length;
                for (let i6 = 0; i6 < len3; i6++) {
                    let data8 = data7[i6];
                    if (typeof data8 !== "string") {
                        let dataType8 = typeof data8;
                        let coerced8 = undefined;
                        if (dataType8 == 'object' && Array.isArray(data8) && data8.length == 1) {
                            data8 = data8[0];
                            dataType8 = typeof data8;
                            if (typeof data8 === "string") {
                                coerced8 = data8;
                            }
                        }
                        if (!(coerced8 !== undefined)) {
                            if (dataType8 == "number" || dataType8 == "boolean") {
                                coerced8 = "" + data8;
                            }
                            else if (data8 === null) {
                                coerced8 = "";
                            }
                            else {
                                const err23 = { instancePath: instancePath + "/languages/" + i6, schemaPath: "#/properties/languages/items/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                    vErrors = [err23];
                                }
                                else {
                                    vErrors.push(err23);
                                }
                                errors++;
                            }
                        }
                        if (coerced8 !== undefined) {
                            data8 = coerced8;
                            if (data7 !== undefined) {
                                data7[i6] = coerced8;
                            }
                        }
                    }
                    if (typeof data8 === "string") {
                        if (func3(data8) > 2) {
                            const err24 = { instancePath: instancePath + "/languages/" + i6, schemaPath: "#/properties/languages/items/maxLength", keyword: "maxLength", params: { limit: 2 }, message: "must NOT have more than 2 characters" };
                            if (vErrors === null) {
                                vErrors = [err24];
                            }
                            else {
                                vErrors.push(err24);
                            }
                            errors++;
                        }
                        if (func3(data8) < 2) {
                            const err25 = { instancePath: instancePath + "/languages/" + i6, schemaPath: "#/properties/languages/items/minLength", keyword: "minLength", params: { limit: 2 }, message: "must NOT have fewer than 2 characters" };
                            if (vErrors === null) {
                                vErrors = [err25];
                            }
                            else {
                                vErrors.push(err25);
                            }
                            errors++;
                        }
                    }
                }
                let i7 = data7.length;
                let j3;
                if (i7 > 1) {
                    const indices3 = {};
                    for (; i7--;) {
                        let item3 = data7[i7];
                        if (typeof item3 !== "string") {
                            continue;
                        }
                        if (typeof indices3[item3] == "number") {
                            j3 = indices3[item3];
                            const err26 = { instancePath: instancePath + "/languages", schemaPath: "#/properties/languages/uniqueItems", keyword: "uniqueItems", params: { i: i7, j: j3 }, message: "must NOT have duplicate items (items ## " + j3 + " and " + i7 + " are identical)" };
                            if (vErrors === null) {
                                vErrors = [err26];
                            }
                            else {
                                vErrors.push(err26);
                            }
                            errors++;
                            break;
                        }
                        indices3[item3] = i7;
                    }
                }
            }
        }
        if (data.coverageTypes !== undefined) {
            let data9 = data.coverageTypes;
            if (!(Array.isArray(data9))) {
                let dataType9 = typeof data9;
                let coerced9 = undefined;
                if (dataType9 == 'object' && Array.isArray(data9) && data9.length == 1) {
                    data9 = data9[0];
                    dataType9 = typeof data9;
                    if (Array.isArray(data9)) {
                        coerced9 = data9;
                    }
                }
                if (!(coerced9 !== undefined)) {
                    if (dataType9 === "string" || dataType9 === "number"
                        || dataType9 === "boolean" || data9 === null) {
                        coerced9 = [data9];
                    }
                    else {
                        const err27 = { instancePath: instancePath + "/coverageTypes", schemaPath: "#/properties/coverageTypes/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                        if (vErrors === null) {
                            vErrors = [err27];
                        }
                        else {
                            vErrors.push(err27);
                        }
                        errors++;
                    }
                }
                if (coerced9 !== undefined) {
                    data9 = coerced9;
                    if (data !== undefined) {
                        data["coverageTypes"] = coerced9;
                    }
                }
            }
            if (Array.isArray(data9)) {
                if (data9.length > 1000) {
                    const err28 = { instancePath: instancePath + "/coverageTypes", schemaPath: "#/properties/coverageTypes/maxItems", keyword: "maxItems", params: { limit: 1000 }, message: "must NOT have more than 1000 items" };
                    if (vErrors === null) {
                        vErrors = [err28];
                    }
                    else {
                        vErrors.push(err28);
                    }
                    errors++;
                }
                if (data9.length < 0) {
                    const err29 = { instancePath: instancePath + "/coverageTypes", schemaPath: "#/properties/coverageTypes/minItems", keyword: "minItems", params: { limit: 0 }, message: "must NOT have fewer than 0 items" };
                    if (vErrors === null) {
                        vErrors = [err29];
                    }
                    else {
                        vErrors.push(err29);
                    }
                    errors++;
                }
                const len4 = data9.length;
                for (let i8 = 0; i8 < len4; i8++) {
                    let data10 = data9[i8];
                    if (typeof data10 !== "string") {
                        let dataType10 = typeof data10;
                        let coerced10 = undefined;
                        if (dataType10 == 'object' && Array.isArray(data10) && data10.length == 1) {
                            data10 = data10[0];
                            dataType10 = typeof data10;
                            if (typeof data10 === "string") {
                                coerced10 = data10;
                            }
                        }
                        if (!(coerced10 !== undefined)) {
                            if (dataType10 == "number" || dataType10 == "boolean") {
                                coerced10 = "" + data10;
                            }
                            else if (data10 === null) {
                                coerced10 = "";
                            }
                            else {
                                const err30 = { instancePath: instancePath + "/coverageTypes/" + i8, schemaPath: "#/properties/coverageTypes/items/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                    vErrors = [err30];
                                }
                                else {
                                    vErrors.push(err30);
                                }
                                errors++;
                            }
                        }
                        if (coerced10 !== undefined) {
                            data10 = coerced10;
                            if (data9 !== undefined) {
                                data9[i8] = coerced10;
                            }
                        }
                    }
                    if (!((((data10 === "Private Health Insurance") || (data10 === "Statutory Health Insurance")) || (data10 === "Self-Payment")) || (data10 === "Reimbursement Procedure"))) {
                        const err31 = { instancePath: instancePath + "/coverageTypes/" + i8, schemaPath: "#/properties/coverageTypes/items/enum", keyword: "enum", params: { allowedValues: schema12.properties.coverageTypes.items.enum }, message: "must be equal to one of the allowed values" };
                        if (vErrors === null) {
                            vErrors = [err31];
                        }
                        else {
                            vErrors.push(err31);
                        }
                        errors++;
                    }
                }
                let i9 = data9.length;
                let j4;
                if (i9 > 1) {
                    const indices4 = {};
                    for (; i9--;) {
                        let item4 = data9[i9];
                        if (typeof item4 !== "string") {
                            continue;
                        }
                        if (typeof indices4[item4] == "number") {
                            j4 = indices4[item4];
                            const err32 = { instancePath: instancePath + "/coverageTypes", schemaPath: "#/properties/coverageTypes/uniqueItems", keyword: "uniqueItems", params: { i: i9, j: j4 }, message: "must NOT have duplicate items (items ## " + j4 + " and " + i9 + " are identical)" };
                            if (vErrors === null) {
                                vErrors = [err32];
                            }
                            else {
                                vErrors.push(err32);
                            }
                            errors++;
                            break;
                        }
                        indices4[item4] = i9;
                    }
                }
            }
        }
        if (data.gender !== undefined) {
            let data11 = data.gender;
            if (!(Array.isArray(data11))) {
                let dataType11 = typeof data11;
                let coerced11 = undefined;
                if (dataType11 == 'object' && Array.isArray(data11) && data11.length == 1) {
                    data11 = data11[0];
                    dataType11 = typeof data11;
                    if (Array.isArray(data11)) {
                        coerced11 = data11;
                    }
                }
                if (!(coerced11 !== undefined)) {
                    if (dataType11 === "string" || dataType11 === "number"
                        || dataType11 === "boolean" || data11 === null) {
                        coerced11 = [data11];
                    }
                    else {
                        const err33 = { instancePath: instancePath + "/gender", schemaPath: "#/properties/gender/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                        if (vErrors === null) {
                            vErrors = [err33];
                        }
                        else {
                            vErrors.push(err33);
                        }
                        errors++;
                    }
                }
                if (coerced11 !== undefined) {
                    data11 = coerced11;
                    if (data !== undefined) {
                        data["gender"] = coerced11;
                    }
                }
            }
            if (Array.isArray(data11)) {
                if (data11.length > 3) {
                    const err34 = { instancePath: instancePath + "/gender", schemaPath: "#/properties/gender/maxItems", keyword: "maxItems", params: { limit: 3 }, message: "must NOT have more than 3 items" };
                    if (vErrors === null) {
                        vErrors = [err34];
                    }
                    else {
                        vErrors.push(err34);
                    }
                    errors++;
                }
                if (data11.length < 0) {
                    const err35 = { instancePath: instancePath + "/gender", schemaPath: "#/properties/gender/minItems", keyword: "minItems", params: { limit: 0 }, message: "must NOT have fewer than 0 items" };
                    if (vErrors === null) {
                        vErrors = [err35];
                    }
                    else {
                        vErrors.push(err35);
                    }
                    errors++;
                }
                const len5 = data11.length;
                for (let i10 = 0; i10 < len5; i10++) {
                    let data12 = data11[i10];
                    if (typeof data12 !== "string") {
                        let dataType12 = typeof data12;
                        let coerced12 = undefined;
                        if (dataType12 == 'object' && Array.isArray(data12) && data12.length == 1) {
                            data12 = data12[0];
                            dataType12 = typeof data12;
                            if (typeof data12 === "string") {
                                coerced12 = data12;
                            }
                        }
                        if (!(coerced12 !== undefined)) {
                            if (dataType12 == "number" || dataType12 == "boolean") {
                                coerced12 = "" + data12;
                            }
                            else if (data12 === null) {
                                coerced12 = "";
                            }
                            else {
                                const err36 = { instancePath: instancePath + "/gender/" + i10, schemaPath: "#/properties/gender/items/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                    vErrors = [err36];
                                }
                                else {
                                    vErrors.push(err36);
                                }
                                errors++;
                            }
                        }
                        if (coerced12 !== undefined) {
                            data12 = coerced12;
                            if (data11 !== undefined) {
                                data11[i10] = coerced12;
                            }
                        }
                    }
                    if (!(((data12 === "female") || (data12 === "male")) || (data12 === "diverse"))) {
                        const err37 = { instancePath: instancePath + "/gender/" + i10, schemaPath: "#/properties/gender/items/enum", keyword: "enum", params: { allowedValues: schema12.properties.gender.items.enum }, message: "must be equal to one of the allowed values" };
                        if (vErrors === null) {
                            vErrors = [err37];
                        }
                        else {
                            vErrors.push(err37);
                        }
                        errors++;
                    }
                }
                let i11 = data11.length;
                let j5;
                if (i11 > 1) {
                    const indices5 = {};
                    for (; i11--;) {
                        let item5 = data11[i11];
                        if (typeof item5 !== "string") {
                            continue;
                        }
                        if (typeof indices5[item5] == "number") {
                            j5 = indices5[item5];
                            const err38 = { instancePath: instancePath + "/gender", schemaPath: "#/properties/gender/uniqueItems", keyword: "uniqueItems", params: { i: i11, j: j5 }, message: "must NOT have duplicate items (items ## " + j5 + " and " + i11 + " are identical)" };
                            if (vErrors === null) {
                                vErrors = [err38];
                            }
                            else {
                                vErrors.push(err38);
                            }
                            errors++;
                            break;
                        }
                        indices5[item5] = i11;
                    }
                }
            }
        }
        if (data.location !== undefined) {
            let data13 = data.location;
            if (!(Array.isArray(data13))) {
                let dataType13 = typeof data13;
                let coerced13 = undefined;
                if (dataType13 == 'object' && Array.isArray(data13) && data13.length == 1) {
                    data13 = data13[0];
                    dataType13 = typeof data13;
                    if (Array.isArray(data13)) {
                        coerced13 = data13;
                    }
                }
                if (!(coerced13 !== undefined)) {
                    if (dataType13 === "string" || dataType13 === "number"
                        || dataType13 === "boolean" || data13 === null) {
                        coerced13 = [data13];
                    }
                    else {
                        const err39 = { instancePath: instancePath + "/location", schemaPath: "#/properties/location/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                        if (vErrors === null) {
                            vErrors = [err39];
                        }
                        else {
                            vErrors.push(err39);
                        }
                        errors++;
                    }
                }
                if (coerced13 !== undefined) {
                    data13 = coerced13;
                    if (data !== undefined) {
                        data["location"] = coerced13;
                    }
                }
            }
            if (Array.isArray(data13)) {
                if (data13.length > 2) {
                    const err40 = { instancePath: instancePath + "/location", schemaPath: "#/properties/location/maxItems", keyword: "maxItems", params: { limit: 2 }, message: "must NOT have more than 2 items" };
                    if (vErrors === null) {
                        vErrors = [err40];
                    }
                    else {
                        vErrors.push(err40);
                    }
                    errors++;
                }
                if (data13.length < 0) {
                    const err41 = { instancePath: instancePath + "/location", schemaPath: "#/properties/location/minItems", keyword: "minItems", params: { limit: 0 }, message: "must NOT have fewer than 0 items" };
                    if (vErrors === null) {
                        vErrors = [err41];
                    }
                    else {
                        vErrors.push(err41);
                    }
                    errors++;
                }
                const len6 = data13.length;
                for (let i12 = 0; i12 < len6; i12++) {
                    let data14 = data13[i12];
                    if (typeof data14 !== "string") {
                        let dataType14 = typeof data14;
                        let coerced14 = undefined;
                        if (dataType14 == 'object' && Array.isArray(data14) && data14.length == 1) {
                            data14 = data14[0];
                            dataType14 = typeof data14;
                            if (typeof data14 === "string") {
                                coerced14 = data14;
                            }
                        }
                        if (!(coerced14 !== undefined)) {
                            if (dataType14 == "number" || dataType14 == "boolean") {
                                coerced14 = "" + data14;
                            }
                            else if (data14 === null) {
                                coerced14 = "";
                            }
                            else {
                                const err42 = { instancePath: instancePath + "/location/" + i12, schemaPath: "#/properties/location/items/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                    vErrors = [err42];
                                }
                                else {
                                    vErrors.push(err42);
                                }
                                errors++;
                            }
                        }
                        if (coerced14 !== undefined) {
                            data14 = coerced14;
                            if (data13 !== undefined) {
                                data13[i12] = coerced14;
                            }
                        }
                    }
                    if (!((data14 === "onSite") || (data14 === "remote"))) {
                        const err43 = { instancePath: instancePath + "/location/" + i12, schemaPath: "#/properties/location/items/enum", keyword: "enum", params: { allowedValues: schema12.properties.location.items.enum }, message: "must be equal to one of the allowed values" };
                        if (vErrors === null) {
                            vErrors = [err43];
                        }
                        else {
                            vErrors.push(err43);
                        }
                        errors++;
                    }
                }
                let i13 = data13.length;
                let j6;
                if (i13 > 1) {
                    const indices6 = {};
                    for (; i13--;) {
                        let item6 = data13[i13];
                        if (typeof item6 !== "string") {
                            continue;
                        }
                        if (typeof indices6[item6] == "number") {
                            j6 = indices6[item6];
                            const err44 = { instancePath: instancePath + "/location", schemaPath: "#/properties/location/uniqueItems", keyword: "uniqueItems", params: { i: i13, j: j6 }, message: "must NOT have duplicate items (items ## " + j6 + " and " + i13 + " are identical)" };
                            if (vErrors === null) {
                                vErrors = [err44];
                            }
                            else {
                                vErrors.push(err44);
                            }
                            errors++;
                            break;
                        }
                        indices6[item6] = i13;
                    }
                }
            }
        }
        if (data.sort !== undefined) {
            let data15 = data.sort;
            if ((typeof data15 !== "string") && (data15 !== null)) {
                let dataType15 = typeof data15;
                let coerced15 = undefined;
                if (dataType15 == 'object' && Array.isArray(data15) && data15.length == 1) {
                    data15 = data15[0];
                    dataType15 = typeof data15;
                    if ((typeof data15 === "string") && (data15 === null)) {
                        coerced15 = data15;
                    }
                }
                if (!(coerced15 !== undefined)) {
                    if (dataType15 == "number" || dataType15 == "boolean") {
                        coerced15 = "" + data15;
                    }
                    else if (data15 === null) {
                        coerced15 = "";
                    }
                    else if (data15 === "" || data15 === 0 || data15 === false) {
                        coerced15 = null;
                    }
                    else {
                        const err45 = { instancePath: instancePath + "/sort", schemaPath: "#/properties/sort/type", keyword: "type", params: { type: schema12.properties.sort.type }, message: "must be string,null" };
                        if (vErrors === null) {
                            vErrors = [err45];
                        }
                        else {
                            vErrors.push(err45);
                        }
                        errors++;
                    }
                }
                if (coerced15 !== undefined) {
                    data15 = coerced15;
                    if (data !== undefined) {
                        data["sort"] = coerced15;
                    }
                }
            }
            if (!(((data15 === "distance") || (data15 === "availability")) || (data15 === null))) {
                const err46 = { instancePath: instancePath + "/sort", schemaPath: "#/properties/sort/enum", keyword: "enum", params: { allowedValues: schema12.properties.sort.enum }, message: "must be equal to one of the allowed values" };
                if (vErrors === null) {
                    vErrors = [err46];
                }
                else {
                    vErrors.push(err46);
                }
                errors++;
            }
        }
        if (data.therapistId !== undefined) {
            let data16 = data.therapistId;
            if (typeof data16 !== "string") {
                let dataType16 = typeof data16;
                let coerced16 = undefined;
                if (dataType16 == 'object' && Array.isArray(data16) && data16.length == 1) {
                    data16 = data16[0];
                    dataType16 = typeof data16;
                    if (typeof data16 === "string") {
                        coerced16 = data16;
                    }
                }
                if (!(coerced16 !== undefined)) {
                    if (dataType16 == "number" || dataType16 == "boolean") {
                        coerced16 = "" + data16;
                    }
                    else if (data16 === null) {
                        coerced16 = "";
                    }
                    else {
                        const err47 = { instancePath: instancePath + "/therapistId", schemaPath: "#/properties/therapistId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                            vErrors = [err47];
                        }
                        else {
                            vErrors.push(err47);
                        }
                        errors++;
                    }
                }
                if (coerced16 !== undefined) {
                    data16 = coerced16;
                    if (data !== undefined) {
                        data["therapistId"] = coerced16;
                    }
                }
            }
            if (typeof data16 === "string") {
                if (!(formats0.validate(data16))) {
                    const err48 = { instancePath: instancePath + "/therapistId", schemaPath: "#/properties/therapistId/format", keyword: "format", params: { format: "decimal" }, message: "must match format \"" + "decimal" + "\"" };
                    if (vErrors === null) {
                        vErrors = [err48];
                    }
                    else {
                        vErrors.push(err48);
                    }
                    errors++;
                }
            }
        }
        if (data.insuranseType !== undefined) {
            let data17 = data.insuranseType;
            if (typeof data17 !== "string") {
                let dataType17 = typeof data17;
                let coerced17 = undefined;
                if (dataType17 == 'object' && Array.isArray(data17) && data17.length == 1) {
                    data17 = data17[0];
                    dataType17 = typeof data17;
                    if (typeof data17 === "string") {
                        coerced17 = data17;
                    }
                }
                if (!(coerced17 !== undefined)) {
                    if (dataType17 == "number" || dataType17 == "boolean") {
                        coerced17 = "" + data17;
                    }
                    else if (data17 === null) {
                        coerced17 = "";
                    }
                    else {
                        const err49 = { instancePath: instancePath + "/insuranseType", schemaPath: "#/properties/insuranseType/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                            vErrors = [err49];
                        }
                        else {
                            vErrors.push(err49);
                        }
                        errors++;
                    }
                }
                if (coerced17 !== undefined) {
                    data17 = coerced17;
                    if (data !== undefined) {
                        data["insuranseType"] = coerced17;
                    }
                }
            }
            if (!((data17 === "legally") || (data17 === "privately"))) {
                const err50 = { instancePath: instancePath + "/insuranseType", schemaPath: "#/properties/insuranseType/enum", keyword: "enum", params: { allowedValues: schema12.properties.insuranseType.enum }, message: "must be equal to one of the allowed values" };
                if (vErrors === null) {
                    vErrors = [err50];
                }
                else {
                    vErrors.push(err50);
                }
                errors++;
            }
        }
        if (data.meetingTypeId !== undefined) {
            let data18 = data.meetingTypeId;
            if (typeof data18 !== "string") {
                let dataType18 = typeof data18;
                let coerced18 = undefined;
                if (dataType18 == 'object' && Array.isArray(data18) && data18.length == 1) {
                    data18 = data18[0];
                    dataType18 = typeof data18;
                    if (typeof data18 === "string") {
                        coerced18 = data18;
                    }
                }
                if (!(coerced18 !== undefined)) {
                    if (dataType18 == "number" || dataType18 == "boolean") {
                        coerced18 = "" + data18;
                    }
                    else if (data18 === null) {
                        coerced18 = "";
                    }
                    else {
                        const err51 = { instancePath: instancePath + "/meetingTypeId", schemaPath: "#/properties/meetingTypeId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                            vErrors = [err51];
                        }
                        else {
                            vErrors.push(err51);
                        }
                        errors++;
                    }
                }
                if (coerced18 !== undefined) {
                    data18 = coerced18;
                    if (data !== undefined) {
                        data["meetingTypeId"] = coerced18;
                    }
                }
            }
            if (typeof data18 === "string") {
                if (!(formats0.validate(data18))) {
                    const err52 = { instancePath: instancePath + "/meetingTypeId", schemaPath: "#/properties/meetingTypeId/format", keyword: "format", params: { format: "decimal" }, message: "must match format \"" + "decimal" + "\"" };
                    if (vErrors === null) {
                        vErrors = [err52];
                    }
                    else {
                        vErrors.push(err52);
                    }
                    errors++;
                }
            }
        }
        if (data.appointmentsFrom !== undefined) {
            let data19 = data.appointmentsFrom;
            if (typeof data19 !== "string") {
                let dataType19 = typeof data19;
                let coerced19 = undefined;
                if (dataType19 == 'object' && Array.isArray(data19) && data19.length == 1) {
                    data19 = data19[0];
                    dataType19 = typeof data19;
                    if (typeof data19 === "string") {
                        coerced19 = data19;
                    }
                }
                if (!(coerced19 !== undefined)) {
                    if (dataType19 == "number" || dataType19 == "boolean") {
                        coerced19 = "" + data19;
                    }
                    else if (data19 === null) {
                        coerced19 = "";
                    }
                    else {
                        const err53 = { instancePath: instancePath + "/appointmentsFrom", schemaPath: "#/properties/appointmentsFrom/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                            vErrors = [err53];
                        }
                        else {
                            vErrors.push(err53);
                        }
                        errors++;
                    }
                }
                if (coerced19 !== undefined) {
                    data19 = coerced19;
                    if (data !== undefined) {
                        data["appointmentsFrom"] = coerced19;
                    }
                }
            }
            if (typeof data19 === "string") {
                if (!(formats4.validate(data19))) {
                    const err54 = { instancePath: instancePath + "/appointmentsFrom", schemaPath: "#/properties/appointmentsFrom/format", keyword: "format", params: { format: "date-time" }, message: "must match format \"" + "date-time" + "\"" };
                    if (vErrors === null) {
                        vErrors = [err54];
                    }
                    else {
                        vErrors.push(err54);
                    }
                    errors++;
                }
            }
        }
        if (data.page !== undefined) {
            let data20 = data.page;
            if (!((typeof data20 == "number") && (isFinite(data20)))) {
                let dataType20 = typeof data20;
                let coerced20 = undefined;
                if (dataType20 == 'object' && Array.isArray(data20) && data20.length == 1) {
                    data20 = data20[0];
                    dataType20 = typeof data20;
                    if ((typeof data20 == "number") && (isFinite(data20))) {
                        coerced20 = data20;
                    }
                }
                if (!(coerced20 !== undefined)) {
                    if (dataType20 == "boolean" || data20 === null
                        || (dataType20 == "string" && data20 && data20 == +data20)) {
                        coerced20 = +data20;
                    }
                    else {
                        const err55 = { instancePath: instancePath + "/page", schemaPath: "#/properties/page/type", keyword: "type", params: { type: "number" }, message: "must be number" };
                        if (vErrors === null) {
                            vErrors = [err55];
                        }
                        else {
                            vErrors.push(err55);
                        }
                        errors++;
                    }
                }
                if (coerced20 !== undefined) {
                    data20 = coerced20;
                    if (data !== undefined) {
                        data["page"] = coerced20;
                    }
                }
            }
            if ((typeof data20 == "number") && (isFinite(data20))) {
                if (data20 < 1 || isNaN(data20)) {
                    const err56 = { instancePath: instancePath + "/page", schemaPath: "#/properties/page/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
                    if (vErrors === null) {
                        vErrors = [err56];
                    }
                    else {
                        vErrors.push(err56);
                    }
                    errors++;
                }
            }
        }
        if (data.limit !== undefined) {
            let data21 = data.limit;
            if (!((typeof data21 == "number") && (isFinite(data21)))) {
                let dataType21 = typeof data21;
                let coerced21 = undefined;
                if (dataType21 == 'object' && Array.isArray(data21) && data21.length == 1) {
                    data21 = data21[0];
                    dataType21 = typeof data21;
                    if ((typeof data21 == "number") && (isFinite(data21))) {
                        coerced21 = data21;
                    }
                }
                if (!(coerced21 !== undefined)) {
                    if (dataType21 == "boolean" || data21 === null
                        || (dataType21 == "string" && data21 && data21 == +data21)) {
                        coerced21 = +data21;
                    }
                    else {
                        const err57 = { instancePath: instancePath + "/limit", schemaPath: "#/properties/limit/type", keyword: "type", params: { type: "number" }, message: "must be number" };
                        if (vErrors === null) {
                            vErrors = [err57];
                        }
                        else {
                            vErrors.push(err57);
                        }
                        errors++;
                    }
                }
                if (coerced21 !== undefined) {
                    data21 = coerced21;
                    if (data !== undefined) {
                        data["limit"] = coerced21;
                    }
                }
            }
            if ((typeof data21 == "number") && (isFinite(data21))) {
                if (data21 > 100 || isNaN(data21)) {
                    const err58 = { instancePath: instancePath + "/limit", schemaPath: "#/properties/limit/maximum", keyword: "maximum", params: { comparison: "<=", limit: 100 }, message: "must be <= 100" };
                    if (vErrors === null) {
                        vErrors = [err58];
                    }
                    else {
                        vErrors.push(err58);
                    }
                    errors++;
                }
                if (data21 < 1 || isNaN(data21)) {
                    const err59 = { instancePath: instancePath + "/limit", schemaPath: "#/properties/limit/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
                    if (vErrors === null) {
                        vErrors = [err59];
                    }
                    else {
                        vErrors.push(err59);
                    }
                    errors++;
                }
            }
        }
    }
    else {
        const err60 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
        if (vErrors === null) {
            vErrors = [err60];
        }
        else {
            vErrors.push(err60);
        }
        errors++;
    }
    validate11.errors = vErrors;
    return errors === 0;
}
//# sourceMappingURL=UserApiCoercing.generated.mjs.map